import type { v4 } from '@sap/ux-specification-types';
import type { FooterActionV4, CustomFooterActionOP } from './ObjectPageFooterAction';

export class ObjectPageFooterActions implements v4.ObjectPageFooterActions {
    [key: string]: FooterActionV4 | CustomFooterActionOP;
}

export class ObjectPageFooter implements v4.ObjectPageFooter {
    actions?: ObjectPageFooterActions;
}
